import React from 'react';

const Events = () => {
  return (
    <div className='flex w-full bg-gray-600 h-screen justify-center items-center'>
     <div className='text-4xl text-yellow-300'> Events </div>
    </div>
  );
};

export default Events;